import {
  ConfiguratorOrientation,
  ConfiguratorPlacing,
  ORIENTATION_TO_ICON,
  PLACING_TO_LABEL,
} from '@eliadmin/core/src/components/configurator/configurator-constants';
import type { FieldProps } from '@eliadmin/core/src/components/configurator/configurator-field';
import { useConfiguratorField } from '@eliadmin/core/src/components/configurator/configurator-field';
import { ConfiguratorFieldLabel } from '@eliadmin/core/src/components/configurator/configurator-field-label';
import { Label } from '@eliadmin/core/src/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@eliadmin/core/src/components/ui/radio-group';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useErrSync } from '@eliadmin/core/src/stores/configurator-store';

export function ConfiguratorRadio({ fieldConfig, field }: FieldProps<'radio'>) {
  const { value, onChange } = useConfiguratorField(fieldConfig);
  const { t } = useTranslations();

  if (field.type !== 'radio') throw new Error(`Invalid field type ${field.type}`);

  const values = field.variant === 'orientation' ? ConfiguratorOrientation : ConfiguratorPlacing;
  const labelMap = field.variant === 'orientation' ? ORIENTATION_TO_ICON : PLACING_TO_LABEL;

  const isInvalid = !value && fieldConfig.must === '1';
  useErrSync(fieldConfig.column, isInvalid);

  return (
    <div className="flex w-full flex-col gap-1">
      <ConfiguratorFieldLabel fieldConfig={fieldConfig} isInvalid={isInvalid} />
      <RadioGroup
        id={fieldConfig.column}
        value={String(value)}
        onValueChange={(value: string) => onChange(value)}
        className="flex flex-row flex-wrap gap-4"
      >
        {Object.values(values).map(item => {
          const label = labelMap[item as keyof typeof labelMap];
          const id = `${fieldConfig.column}_${item}`;
          return (
            <Label
              key={item}
              className="flex cursor-pointer items-center justify-start gap-1  rounded-lg py-2 transition"
              htmlFor={id}
            >
              <RadioGroupItem
                value={String(item)}
                id={id}
                className="h-6 w-6 border-accent text-accent data-[state=checked]:bg-accent"
              />
              {typeof label === 'string' ? t(label) : label}
            </Label>
          );
        })}
      </RadioGroup>
    </div>
  );
}
